export default {
  BOX: 'box'
};


/** WEBPACK FOOTER **
 ** ./examples/05 Customize/Drop Effects/ItemTypes.js
 **/